import { Popup } from 'components/common/popup/Popup';
import { useState } from 'react';
import { Typography } from '@mui/material';

export default function PopupWrapper({ props }: { props: any }) {
    const [open, setOpen] = useState(true);

    return (
        <Popup
            settings={{
                title: 'string' === typeof props.title ? props.title : 'Info',
                needTranslation: false,
                textOK: 'string' === typeof props.textOK ? props.textOK : 'OK',
                colorOk: 'string' === typeof props.colorOk ? props.colorOk : undefined,
                iconOK: 'string' === typeof props.iconOK ? props.iconOK : undefined,
                textCancel: 'string' === typeof props.textCancel ? props.textCancel : undefined,
                noCancel: 'boolean' === typeof props.noCancel ? props.noCancel : false,
                noOk: 'boolean' === typeof props.noOk ? props.noOk : false,
                noButtons: 'boolean' === typeof props.noButtons ? props.noButtons : false,
            }}
            open={open}
            onHide={() => setOpen(false)}
            onConfirm={() => {
                setOpen(false);
            }}
            maxWidth={'popupSm'}
        >
            {true === props.html && <div dangerouslySetInnerHTML={{ __html: props.text }}></div>}
            {true !== props.html && <Typography>{props.text}</Typography>}
        </Popup>
    );
}
